// SEO Configuration
export const seoConfig = {
  // Site domain - change this for your production URL
  siteUrl: 'http://localhost:3000',
  
  // For local development, uncomment this:
  // siteUrl: 'http://localhost:3000',
  
  // Default meta tags
  defaultTitle: 'Web Developer Interview Questions - React, JavaScript, TypeScript & More',
  defaultDescription: 'Master your next frontend interview with comprehensive questions and answers covering React, JavaScript, TypeScript, CSS, OOP, React Native, Scrum, and live coding. Real interview questions with detailed explanations.',
  defaultKeywords: 'web developer interview, frontend interview questions, React interview, JavaScript interview, TypeScript interview, CSS interview, coding interview, programming interview, interview preparation, developer questions',
  
  // Social media
  siteName: 'The Web Dev Interview',
  twitterHandle: '@webdevinterview', // Update with actual handle
  
  // Images
  defaultOgImage: '/og-image.jpg',
  
  // Organization info for structured data
  organization: {
    name: 'The Web Dev Interview',
    url: 'http://localhost:3000',
  },
};

// Helper function to build full URLs
export const buildUrl = (path = '') => {
  const base = seoConfig.siteUrl.replace(/\/$/, ''); // Remove trailing slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};

// Helper function to build image URLs
export const buildImageUrl = (imagePath) => {
  if (imagePath.startsWith('http')) return imagePath;
  return buildUrl(imagePath);
};
